<template>
<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8715_15822)">
<path d="M11 26.1201L25.532 52.0951V67.9391L11.017 93.8631L11 26.1201Z" fill="#5B57A2"/>
<path d="M66.7969 42.643L80.4139 34.297L108.282 34.271L66.7969 59.685V42.643Z" fill="#D90751"/>
<path d="M66.7204 25.967L66.7974 60.357L52.2314 51.407V0L66.7204 25.967Z" fill="#FAB718"/>
<path d="M108.282 34.271L80.4134 34.297L66.7204 25.967L52.2314 0L108.282 34.271Z" fill="#ED6F26"/>
<path d="M66.7974 94.007V77.322L52.2314 68.542L52.2394 120L66.7974 94.007Z" fill="#63B22F"/>
<path d="M80.38 85.7371L25.531 52.0951L11 26.1201L108.223 85.7031L80.38 85.7371Z" fill="#1487C9"/>
<path d="M52.2402 120L66.7962 94.0071L80.3792 85.7371L108.222 85.7031L52.2402 120Z" fill="#017F36"/>
<path d="M11.0166 93.8631L52.3496 68.5431L38.4536 60.0171L25.5316 67.9391L11.0166 93.8631Z" fill="#984995"/>
</g>
<defs>
<clipPath id="clip0_8715_15822">
<rect width="120" height="120" fill="white"/>
</clipPath>
</defs>
</svg>


  
  </template>
  
  